import { tracker } from '../track';
export const trackViewContent = (element, { contentId, info, length, context, themeHash, } = {}) => {
    const viewContent = {
        element: element,
        content_type: 'view',
        content_id: null,
        info: null,
        length: undefined,
        context: null,
        theme_hash: themeHash || null,
    };
    if (contentId) {
        viewContent.content_id = contentId;
    }
    if (info) {
        viewContent.info = info;
    }
    if (length) {
        viewContent.length = length;
    }
    if (context) {
        viewContent.context = context;
    }
    tracker.track('GA4-view_content', {
        event_name: 'view_content',
        view_content: viewContent,
    });
};
